import React from 'react';
import { Feather } from 'lucide-react';
export function FinalResult() {
  return <section className="py-32 px-4 bg-zinc-900/20 relative overflow-hidden" data-id="element-51">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(217,119,6,0.05)_0%,transparent_70%)]" data-id="element-52"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-53">
        <Feather className="w-12 h-12 text-amber-500/50 mx-auto mb-8" data-id="element-54" />

        <div className="space-y-8 mb-12" data-id="element-55">
          <p className="text-2xl md:text-3xl text-zinc-300 font-light italic" data-id="element-56">
            "Imagina despertar sin ese nudo constante en el estómago."
          </p>
          <p className="text-2xl md:text-3xl text-zinc-300 font-light italic" data-id="element-57">
            "Imagina que el nombre de esa persona te sea tan indiferente como el
            de un extraño en la calle."
          </p>
        </div>

        <div className="inline-block border-y border-amber-500/30 py-6 px-8" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-serif text-amber-400 mb-2" data-id="element-59">
            La Paz es tu Profecía.
          </h2>
          <p className="text-xl text-zinc-400 uppercase tracking-widest text-sm mt-4" data-id="element-60">
            El ciclo ha terminado porque{' '}
            <span className="text-zinc-100 font-bold" data-id="element-61">TÚ</span> así lo has
            decidido.
          </p>
        </div>
      </div>
    </section>;
}